// cr footer
"use client"

import Image from "next/image";
import { CR_NAV, FOOTER_CONTENT } from "./common/constant";

const CRFooter = () =>{

    return(
        <div className="w-full cr-footer-wrap h-[144px] umd:h-[323px] text-white bg-black relative bottom-0">
            <div className="px-[92px] py-[35px] blg:px-[3%] umd:py-[55px] umd:px-[37px] text-center w-full asm:max-w-[1440px] flex justify-between umd:flex-col m-auto">
                {/* title */}
                <div className="w-[340px] usm:w-[82vw] h-[35px] umd:m-auto umd:mb-[45px] my-auto umd:w-auto">
                    <Image
                        alt="crypto read"
                        width={340}
                        height={35}
                        className="aspect-[340/35]"
                        src="/images/cryptoread/footer.svg"
                    />
                </div>
                <div className="flex flex-col items-end umd:items-center gap-y-[17px] w-[50%] umd:w-full umd:gap-[45px] blg:mt-[25px]">
                    <div className="button-wrap text-bd4n flex items-center justify-center gap-[28px]">
                        <button onClick={()=>window.location.href = CR_NAV?.FAQ?.link}>{FOOTER_CONTENT?.[2]}</button>
                        <span className="w-[1px] h-[14px] bg-white mt-[15px] translate-y-[-50%]"></span>
                        <button onClick={()=>window.location.href = CR_NAV?.PRIVACY?.link}>{FOOTER_CONTENT?.[0]}</button>
                        <span className="w-[1px] h-[14px] bg-white mt-[15px] translate-y-[-50%]"></span>
                        <button onClick={()=>window.location.href = CR_NAV?.UNSUBSCRIBE?.link}>{FOOTER_CONTENT?.[1]}</button>
                    </div>

                    <p className="text-bd1n !font-[100] umd:w-[calc(341px-50px)] whitespace-nowrap umd:whitespace-normal">Copyright © 2024 Crypto City All Rights Reserved</p>

                </div>
            </div>
        </div>
    )
}

export default CRFooter;